export const loginMessageCompany = `Hinweis: Du versuchst, dich mit dem Kundenkonto eines Vereins, einer Schule oder einer Firma anzumelden, die aktuell gewählte Versicherung ist aber nur für Privatpersonen verfügbar.

Wenn du dich anmeldest wird der aktuelle Bestellvorgang abgebrochen und evtl. bereits eingegebene Daten gehen verloren.

Bitte bestätige, dass du mit der Anmeldung fortfahren möchtest, oder wähle "abbrechen" um zum Bestellvorgang zurückzukehren.`;

export const loginMessagePerson = `Hinweis: Du versuchst, dich mit dem Kundenkonto einer Privatperson anzumelden, die aktuell gewählte Versicherung ist aber nur für gewerbliche Kunden, Schulen und Vereine verfügbar.

Wenn du dich anmeldest wird der aktuelle Bestellvorgang abgebrochen und evtl. bereits eingegebene Daten gehen verloren.

Bitte bestätige, dass du mit der Anmeldung fortfahren möchtest, oder wähle "abbrechen" um zum Bestellvorgang zurückzukehren.`;
